import { render, staticRenderFns } from "./ExtendOtherNutrientsPantothenicAcid.vue?vue&type=template&id=2dfaf442&scoped=true"
import script from "./ExtendOtherNutrientsPantothenicAcid.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsPantothenicAcid.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsPantothenicAcid.vue?vue&type=style&index=0&id=2dfaf442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfaf442",
  null
  
)

export default component.exports